import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { responseInterceptor, errorInterceptor } from './interceptors';
import { Environment } from '../../../environment';

// --- Criação da instância principal ---
const Apicadastro = axios.create({
  baseURL: Environment.URL_BASECADASTRO,
});

// --- Função para anexar interceptores dinâmicos ---
const attachTokenInterceptor = (apiInstance: AxiosInstance) => {
  // Interceptor de requisição — atualiza token antes de cada chamada
  apiInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const token = localStorage.getItem('APP_ACCESS_TOKEN');

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        delete config.headers.Authorization;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  // Interceptor de resposta — reaproveita seus tratadores globais
  apiInstance.interceptors.response.use(
    (response) => responseInterceptor(response),
    (error) => errorInterceptor(error)
  );
};

// --- Aplica os interceptores ---
attachTokenInterceptor(Apicadastro);

export { Apicadastro };
